<template>
    <div class="companyInfo">
        <img src="http://47.94.58.162/rotech-xyjq-admin/res/v2/images/foot-logo.png" alt="图片不存在">
        <div class="leftBox">
            <span class="name">山东省信用金桥中小企业发展服务有限公司</span><br>
            <span class="address">地址：山东济南市中区英雄山路129号祥泰广场（新金融中心）7栋</span>
        </div>
        <div class="rightBox">
            <span>业务指导单位：山东省地方金融监督管理局</span><br>
            <span>监管单位：中国人民银行济南分行</span>
        </div>

        <div class="filingInfo">
            <div class="text">
                山东省信用金桥中小企业发展服务有限公司版权所有
            </div>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=[37010302001158]"
                style="color: rgba(255,255,255,0.6);">
                <img src="http://47.94.58.162/rotech-xyjq-admin/res/v2/images/galg.png" />
                <span>鲁公网安备 [[37010302001158]]号</span>
            </a>
            <span>|</span>
            <a class="ICPNum" href="https://beian.miit.gov.cn" target="_blank">
                鲁ICP备16001926号-4
            </a>
        </div>

    </div>
</template>

<script>
export default {
    name: "CompanyInfo"
}
</script>

<style scoped>
.companyInfo {
    width: 1920px;
    height: 226px;
    padding-left: 360px;
    padding-top: 50px;
    background-color: #242424;
}

.companyInfo>img {
    width: 70px;
    float: left;
}

.companyInfo .leftBox {
    width: 510px;
    height: 85px;
    margin-left: 20px;
    padding-top: 30px;
    float: left;
    /* text-align: center; */
}

.companyInfo .leftBox .name {
    color: #fff;
}

.companyInfo .leftBox .address {
    font-size: 14px;
}

.companyInfo .rightBox {
    width: 600px;
    height: 87px;
    float: left;
    padding-top: 30px;
    text-align: right;
}

.companyInfo .rightBox span {
    font-size: 14px;
}

.filingInfo {
    width: 500px;
    height: 50px;
    margin-top: 120px;
    margin-left: 390px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
}

.filingInfo .text {
    width: 500px;
    font-size: 12px;
}

.filingInfo>span {
    margin: 0 10px;
    color: rgba(255, 255, 255, 0.6);
}

.filingInfo a p {
    height: 20px;
    line-height: 20px;
    margin: 0px 0px 0px 5px;
}

.filingInfo .ICPNum {
    height: 20px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
}</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/CompanyInfo.vue